import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-project-en',
  templateUrl: './help-project-en.component.html',
  styleUrls: ['help-project.component-en.scss']
})
export class HelpProjectEnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
